module.exports = __webpack_public_path__ + "assets/img/hd-share-img01.bc790071.jpg";